import { config } from "../game/consts/config";
import { GameState } from "../game/consts/GameState";
import { Game } from "../game/logic/Game";
import { throw_expression } from "../utils/flow-control";

export class Statistics {
    // logic
    public game_scores_by_time: Array<Array<number>> = [];
    public last_update_time_stamp: number = performance.now();
    public update_interval_ms: number = 500;
    // drawing
    public context: CanvasRenderingContext2D;
    public readonly steps_in_curve: number;
    public games_scores_curves: Array<Array<number>> = [];
    public highest_score: number = 100;
    public has_print_result: boolean = false;

    constructor(
        public canvas: HTMLCanvasElement,
        public games: Array<Game>,
    ) {
        this.context = canvas.getContext("2d") || throw_expression();
        this.context.imageSmoothingEnabled = false;
        this.games_scores_curves = [...new Array(this.games.length)].map((game) => []);
        this.game_scores_by_time = [...new Array(this.games.length)].map((game) => []);
        this.steps_in_curve = canvas.width;
    }

    public update() {
        if (!this.is_time_to_update()) return;
        if (!this.is_anyone_left_playing()) {
            if (this.has_print_result) return;
            this.highest_score = 0;
            this.has_print_result = true;
        }
        this.games.forEach((game, index) => {
            const score = game.get_score();
            let score_timeline = this.game_scores_by_time[index];
            // add score to timline
            score_timeline.push(score);
            this.highest_score = Math.max(score + 2, this.highest_score);
        });
        // get the next highest order of the highest score
        if (!this.has_print_result) this.highest_score = Math.pow(2, Math.ceil(Math.log2(this.highest_score)));
        this.games.forEach((_, index) => {
            let score_timeline = this.game_scores_by_time[index];
            let score_curve = this.games_scores_curves[index];
            // update the curve based on timeline
            //
            // @todo performance
            // let step_multiply = Math.log2(1 / this.steps_in_curve);
            // const timeline_index = score_timeline.length - Math.floor(Math.pow(score_timeline.length, 1 - timeline_fraction));
            for (let i = 0; i < this.steps_in_curve; i++) {
                const timeline_index = this.skew_x_axis(i, score_timeline.length);
                score_curve[i] = score_timeline[timeline_index] / this.highest_score;
            }
        });
        this.redraw();
        this.last_update_time_stamp = performance.now();

    }

    private skew_x_axis(x: number, timeline_length: number): number {
        const timeline_fraction = x / this.steps_in_curve;
        if (!this.is_anyone_left_playing()) {
            return Math.floor(timeline_fraction * timeline_length);
        }
        // from 0 - 1 on the index
        // // jump more points early on to get a later precision of 1 to 1
        return timeline_length - Math.floor(Math.pow(timeline_length, 1 - timeline_fraction));
    }

    private redraw() {
        this.context.fillStyle = "white";
        this.context.lineWidth = 1;
        this.context.strokeStyle = "black";
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.games_scores_curves.forEach((curve, index) => {
            this.context.strokeStyle = "hsl(" + index * 360 / config.players + "deg 100% 50%)";
            this.context.beginPath();
            console.log(!!this.canvas.previousElementSibling);
            this.context.moveTo(0, this.canvas.height);
            curve.forEach((y, x) => {
                this.context.lineTo(
                    (x + 1) * this.canvas.width / this.steps_in_curve,
                    (1 - y) * this.canvas.height,
                );
            });
            this.context.stroke();
        });
    }

    private is_time_to_update(): boolean {
        return performance.now() - this.last_update_time_stamp > this.update_interval_ms;
    }
    private is_anyone_left_playing(): boolean {
        return this.games.reduce((result: boolean, game: Game): boolean => {
            return result || (game.state === GameState.PLAYING);
        }, false);
    }
}